import { HOURS_IN_DAY, MILLISECONDS_IN_HOUR } from "../unit-utils/time";

export function addDays(oldDate: Date, daysToAdd: number): Date {
    return new Date(oldDate.getTime() + daysToAdd * HOURS_IN_DAY * MILLISECONDS_IN_HOUR);
}
